import Cookies from 'universal-cookie';

const AUTH_SESSIONS_COUNT_COOKIE = 'auth_sessions_count';

export const setAuthSessionsCountCookie = () => {
    const cookies = new Cookies();
    const currentCount = cookies.get(AUTH_SESSIONS_COUNT_COOKIE);
    const newCount = currentCount ? Number(currentCount) + 1 : 1;

    cookies.set(AUTH_SESSIONS_COUNT_COOKIE, newCount.toString(), {
        secure: true,
        sameSite: 'lax',
        maxAge: 2592000, // 30 days
        path: '/',
    });
};
